import {
  FETCH_EPISODE_DAY_FAILURE,
  FETCH_EPISODE_DAY_REQUEST,
  FETCH_EPISODE_DAY_SUCCESS,
  FETCH_EPISODE_LISTENERS_FAILURE,
  FETCH_EPISODE_LISTENERS_REQUEST,
  FETCH_EPISODE_LISTENERS_SUCCESS,
  FETCH_FEED_DAY_FAILURE,
  FETCH_FEED_DAY_REQUEST,
  FETCH_FEED_DAY_SUCCESS,
  FETCH_FEED_LISTENERS_FAILURE,
  FETCH_FEED_LISTENERS_REQUEST,
  FETCH_FEED_LISTENERS_SUCCESS,
  FETCH_SNAPSHOT_FAILURE,
  FETCH_SNAPSHOT_REQUEST,
  FETCH_SNAPSHOT_SUCCESS,
} from "./actionTypes";
import type { ListenerCollection } from "./reducer";
import type { FetchSnapshotRequestParams } from "./types";

export const fetchFeedDayRequest = (params: Record<string, unknown>) => ({
  type: FETCH_FEED_DAY_REQUEST,
  payload: params,
});
export const fetchFeedDaySuccess = (data: Record<string, unknown>) => ({
  type: FETCH_FEED_DAY_SUCCESS,
  payload: data,
});
export const fetchFeedDayFailure = (error: string) => ({
  type: FETCH_FEED_DAY_FAILURE,
  payload: error,
});

export const fetchEpisodeDayRequest = (params: Record<string, unknown>) => ({
  type: FETCH_EPISODE_DAY_REQUEST,
  payload: params,
});
export const fetchEpisodeDaySuccess = (data: Record<string, unknown>) => ({
  type: FETCH_EPISODE_DAY_SUCCESS,
  payload: data,
});
export const fetchEpisodeDayFailure = (error: string) => ({
  type: FETCH_EPISODE_DAY_FAILURE,
  payload: error,
});

export const fetchFeedListenersRequest = (params: Record<string, unknown>) => ({
  type: FETCH_FEED_LISTENERS_REQUEST,
  payload: params,
});
export const fetchFeedListenersSuccess = (data: ListenerCollection) => ({
  type: FETCH_FEED_LISTENERS_SUCCESS,
  payload: data,
});
export const fetchFeedListenersFailure = (error: string) => ({
  type: FETCH_FEED_LISTENERS_FAILURE,
  payload: error,
});

export const fetchEpisodeListenersRequest = (params: Record<string, unknown>) => ({
  type: FETCH_EPISODE_LISTENERS_REQUEST,
  payload: params,
});
export const fetchEpisodeListenersSuccess = (data: ListenerCollection) => ({
  type: FETCH_EPISODE_LISTENERS_SUCCESS,
  payload: data,
});
export const fetchEpisodeListenersFailure = (error: string) => ({
  type: FETCH_EPISODE_LISTENERS_FAILURE,
  payload: error,
});

export const fetchSnapshotRequest = (params: FetchSnapshotRequestParams) => ({
  type: FETCH_SNAPSHOT_REQUEST,
  payload: params,
});
export const fetchSnapshotSuccess = (data: Record<string, unknown>) => ({
  type: FETCH_SNAPSHOT_SUCCESS,
  payload: data,
});
export const fetchSnapshotFailure = (error: string) => ({
  type: FETCH_SNAPSHOT_FAILURE,
  payload: error,
});
